module.exports = __webpack_public_path__ + "img/logoBlack.a2077ecc.png";